import React, { useState, useEffect, useRef, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  TextInput,
  SelectInput,
} from "../../components/common/UI/Inputs/InputControls";
import DatePickerComponent from "../../components/common/UI/Inputs/InputControls/DateInput.jsx";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import { sendPhotosActions, myContactsActions } from "../../_store";
import useDraft from "../../components/common/autoSaveDraftMsg/useDraft";
import { inboxActions } from "../../_store";
import {
  getPastDate,
  getcurrentDate,
  getBeforeDate,
} from "../../utils/formatTime";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import ConfirmationModal from "../../components/common/UI/Inputs/NotificationModal/BootstrapModalPopup";
import FreshchatWidget from "../../components/FreshchatWidget";
import translations from "../../config/TranslateFile.jsx";
import { subMonths, isBefore, isAfter } from "date-fns";
import {
  CreateEventLogTextFileForInbox,
  EventLog,
} from "../../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../../utils/routeTracker.js";
import { getStoredValue, setStoredValue } from "../../_helpers/storagehelper.js";
const Inbox = () => {
  const userID = getStoredValue("userID");
  const location = useLocation();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const defaultParams = {
    userID: userID,
    inmateID: location.state?.findInboxMessage?.InmateID
      ? location.state?.findInboxMessage?.InmateID
      : 0,
    subject: "",
    fromDate: "",
    toDate: "",
    messageStatus: 0,
    pageNo: 1,
    rowCountPerPage: 10,
    sortField: "",
  };
  const currentLang = translations();
  const [showSearchFields, setShowSearchFields] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(defaultParams?.pageNo);
  // Auto Draft save
  const { setIsSaveDraftModified } = useDraft();
  const [hasMoreData, setHasMoreData] = useState(true);
  const [pageNo, setPageNo] = useState(1); 
  const [searchpageNo, setSearchpageNo] = useState(0);
  const [isSearch, setIsSearch] = useState(false);
  const [loadedPages, setLoadedPages] = useState(new Set());
  const [searchloadedPages, setSearchLoadedPages] = useState(new Set());
  const [pendingSearch, setPendingSearch] = useState(null);
  const [isPaymentMsg, setIsPaymentMsg] = useState(false);
  const [isPurchaseHistoryConfirm, setIsPurchaseHistoryConfirm] =
    useState(false);
  const [purchaseCreditInmateID, setPurchaseCreditInmateID] = useState(false);
  const [purchaseMessageId, setPurchaseMessageId] = useState(false);
  const [paymentMsg, setPaymentMsg] = useState("");
  const [popMessage, setPopMessage] = useState(null);
  const [confirmBtnName, setconfirmBtnName] = useState(null);
  const [cancelBtnName, setcancelBtnName] = useState(null);
  const { isSignalRData } = useSelector((state) => state.auth);

  useEffect(() => {
    const savedDraft = getStoredValue("draft");
    if (savedDraft != null) {
      setIsSaveDraftModified(true);
    }
  }, [setIsSaveDraftModified]);

  const InmateDrpList = useSelector(
    (x) => x.myContacts.PublicMyContactsDisplayNew
  );

  const currentMenuName = useSelector((x) => x.master.currentMenuName);

  const { loading } = useSelector((state) => state.sendPhotos);

  const { inboxMessagesList } = useSelector((state) => state.inbox);

  const [filteredInboxMessageList, setFilteredInboxMessageList] = useState([]);
  const [previousFilteredPhotos, setPreviousFilteredPhotos] = useState([]);

  const StatusOptions = [
    { value: 0, label: currentLang?.DropDown?.All },
    { value: 1, label: currentLang?.DropDown?.COD },
    { value: 2, label: currentLang?.DropDown?.Read },
    { value: 3, label: currentLang?.DropDown?.Unread },
    // { value: "5", label: "Waiting" },
  ];

  // Initial state for findInboxMessage
  const InitialFindInboxMessage = {
    userID: userID,
    InmateID: 0,
    FromDate: getBeforeDate(30),
    ToDate: getcurrentDate(1),
    MessageStatus: 0,
    Subject: "", // Ensure this is set to an empty string initially
    StatusOptions: 0, // Default to "All"
  };

  const [findInboxMessage, setFindInboxMessage] = useState(
    InitialFindInboxMessage
  );
  const isRestoringFilterRef = useRef(!!location.state?.findInboxMessage);
  const isSearchRef = useRef(isSearch);
  const findInboxMessageRef = useRef(findInboxMessage);
  const currentPageRef = useRef(currentPage);
  useEffect(() => {
    isSearchRef.current = isSearch;
  }, [isSearch]);

  useEffect(() => {
    findInboxMessageRef.current = findInboxMessage;
  }, [findInboxMessage]);

  useEffect(() => {
    currentPageRef.current = currentPage;
  }, [currentPage]);


  // On return to Inbox page
  useEffect(() => {
    if (location.state?.findInboxMessage) {
      // Extract and set default search parameters
      const defaultSearchParams = {
        userID: parseInt(location.state?.findInboxMessage?.userID) || 0,
        InmateID: location.state?.findInboxMessage?.InmateID || 0,
        FromDate: location.state?.findInboxMessage?.FromDate || "",
        ToDate: location.state?.findInboxMessage?.ToDate || "",
        MessageStatus: location.state?.findInboxMessage?.MessageStatus || 0,
        Subject: location.state?.findInboxMessage?.Subject || "",
        StatusOptions: location.state?.findInboxMessage?.StatusOptions || 0,
      };

      // Update state with the merged values
      setFindInboxMessage((prev) => ({
        ...prev,
        ...defaultSearchParams,
      }));
      setPendingSearch(location.state?.findInboxMessage?.InmateID);
    } else if (!location.state?.findInboxMessage) {
      LoadInboxItems();
    }
  }, []);

  useEffect(() => {
    if (pendingSearch !== null) {
      setShowSearchFields(true);
      handleSearch(false, pendingSearch);
      setPendingSearch(null); // Reset after execution
    }
  }, [pendingSearch]);

  useEffect(() => {
    if (isRestoringFilterRef.current) {
      return;
    }
    if (isSearchRef.current) {
      return;
    }

    if (isSignalRData?.message?.InmatesId) {
      const inmateID =
        location.state?.findInboxMessage?.InmateID === 0
          ? 0
          : location.state?.findInboxMessage?.InmateID || 0;
      const updatedParams = { ...defaultParams, inmateID, pageNo: currentPage };
      dispatch(
        inboxActions.LoadInboxMessages({ ...updatedParams, pageNo: currentPage })
      ).then((response) => {
        if (response?.meta?.requestStatus === "fulfilled") {
          setFilteredInboxMessageList(response.payload);
        }
      })
    }

    switch (isSignalRData?.type) {
      case "Approved_Quarantine_Msg":
        const inmateID = isSignalRData?.message?.GetDatasOfMessage?.inmateID || 0;
        const updatedParams = { ...defaultParams, inmateID, pageNo: currentPage };
        dispatch(
          inboxActions.LoadInboxMessages({ ...updatedParams, pageNo: currentPage })
        ).then((response) => {
          if (response?.meta?.requestStatus === "fulfilled") {
            setFilteredInboxMessageList(response.payload);
          }
        })
        break;
    }
  }, [isSignalRData]);

  const LoadInboxItems = useCallback(() => {
    // Load initial messages when component mounts
    showLoader();
    // Load initial messages when component mounts
    const inmateID =
      location.state?.findInboxMessage?.InmateID === 0
        ? 0
        : location.state?.findInboxMessage?.InmateID || 0;

    // Update the `inmateID` in the `defaultParams` before dispatching
    const updatedParams = { ...defaultParams, inmateID, pageNo: currentPage };

    dispatch(
      inboxActions.LoadInboxMessages({ ...updatedParams, pageNo: currentPage })
    ).then((response) => {
      if (response?.meta?.requestStatus === "fulfilled") {
        hideLoader();
        setFilteredInboxMessageList(response.payload);
        setHasMoreData(true);
        if (response?.payload?.length < updatedParams?.rowCountPerPage) {
          setHasMoreData(false); // No more data available, hide "Load More"
          hideLoader();
        }
        if (response?.payload?.length === 0) {
          setIsSearch(true);
        }
      } else {
        hideLoader();
        setHasMoreData(false); // No more data available
      }

      CreateEventLogTextFileForInbox(
        dispatch,
        `Load Inbox Message List - ${updatedParams?.rowCountPerPage} Records per page`,
        "---",
        JSON?.stringify(response),
        " Message Count - " + response?.payload?.length
      );

    });
  }, [dispatch]);

  useEffect(() => {
    if (location.state?.findInboxMessage) {
      return;
    }
    const currentDate = new Date();
    setFindInboxMessage((prev) => ({
      ...prev,
      FromDate: getBeforeDate(30),
      ToDate: currentDate,
    }));
  }, []);

  const handleDateChange = (date, field) => {
    const currentDate = new Date();

    setFindInboxMessage((prevState) => {
      const newState = { ...prevState };

      if (field === "FromDate") {
        // Restrict FromDate to 1 month before current date to the current date
        // const oneMonthAgo = subMonths(currentDate, 1);
        // if (isBefore(date, oneMonthAgo)) {
        //     //newState[field] = formatDate(oneMonthAgo);
        // } else
        if (isAfter(date, currentDate)) {
          newState[field] = formatDate(currentDate);
        } else {
          newState[field] = formatDate(date);
        }
      }

      if (field === "ToDate") {
        // Restrict ToDate between FromDate and the current date
        if (isBefore(date, prevState.FromDate)) {
          newState[field] = formatDate(prevState.FromDate);
        } else if (isAfter(date, currentDate)) {
          newState[field] = formatDate(currentDate);
        } else {
          newState[field] = formatDate(date);
        }
      }

      return newState;
    });
  };

  const handleBlur = (field) => {
    const currentDate = new Date();
    setFindInboxMessage((prevState) => {
      const newState = { ...prevState };

      if (field === "FromDate") {
        if (!prevState.FromDate) {
          newState.FromDate = getBeforeDate(30); // Default to one month ago
        } else {
          const oneMonthAgo = getBeforeDate(30);
          if (isBefore(prevState.FromDate, oneMonthAgo)) {
            newState.FromDate = oneMonthAgo;
          } else if (isAfter(prevState.FromDate, currentDate)) {
            newState.FromDate = currentDate;
          }
        }
      }

      if (field === "ToDate") {
        if (!prevState.ToDate) {
          newState.ToDate = currentDate; // Default to current date
        } else {
          if (isBefore(prevState.ToDate, prevState.FromDate)) {
            newState.ToDate = prevState.FromDate;
          } else if (isAfter(prevState.ToDate, currentDate)) {
            newState.ToDate = currentDate;
          }
        }
      }

      return newState;
    });
  };

  const handleChange = (e, field) => {
    setFindInboxMessage((prev) => ({
      ...prev,
      [field]: e.target.value, // Update the specific field in state
    }));
  };

  const handleSelectChange = (selectedOption, field) => {
    if (field == "StatusOptions") {
      setFindInboxMessage((prev) => ({
        ...prev,
        [field]: selectedOption != null ? selectedOption.value : 0, // Update with selected value
      }));
    } else {
      setFindInboxMessage((prev) => ({
        ...prev,
        [field]:
          selectedOption != null && selectedOption?.value !== ""
            ? selectedOption.value
            : 0, // Update with selected value
      }));
    }
  };

  // Function used for load inmate name
  useEffect(() => {
    let inmatesId = 0;
    // let userID = UserId;
    let userId = getStoredValue("userID");
    let activeStatus = 0;
    let sortField = "InmateName asc";
    let inmateLoadPurpose = "All";
    dispatch(
      myContactsActions.PublicMyContactsDisplayNew({
        userId,
        inmatesId,
        inmateLoadPurpose,
        activeStatus,
        sortField,
      })
    );
  }, [dispatch]);

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const handleClick = (messages) => {
    let PUIConnectionIDArray = InmateDrpList.filter(
      (item) => item.InmateID === messages?.InmateID
    );
    let PUIConnectionID =
      PUIConnectionIDArray.length > 0
        ? PUIConnectionIDArray[0].PUIConnectionID
        : null; // Handle empty result

    navigate("/public/Messenger", {
      state: {
        MessageID: messages?.MessageID,
        PublicUserID: messages?.PublicUserID,
        CODMessageCount: messages?.CODMessageCount,
        PUIConnectionID: PUIConnectionID,
        findInboxMessage: findInboxMessage,
        from: location.pathname,
        inmateID: purchaseCreditInmateID,
        messages: messages,
      },
    });
    storeCurrentRoute("/public/Messenger");
  };

  const getStatusString = (statusValue) => {
    switch (statusValue) {
      case "2":
        return "Read";
      case "3":
        return "Unread";
      case "4":
        return "Rejected";
      case "5":
        return "Waiting";
      default:
        return "All"; // For "1" or any unexpected values, treat as "All"
    }
  };

  const handleLoadMore = async () => {
    // Calculate the new page number
    const newPageNo = pageNo + 1;

    // Check if the page has already been loaded to prevent re-fetching
    if (loadedPages.has(newPageNo)) {
      setHasMoreData(false);
      return;
    }
    const updatedParams = {
      ...defaultParams,
      pageNo: newPageNo,
    };
    showLoader();
    dispatch(inboxActions.LoadInboxMessages(updatedParams)).then((response) => {
      if (response?.meta?.requestStatus === "fulfilled") {
        hideLoader();
        setFilteredInboxMessageList((prev) => [...prev, ...response.payload]); // Append new data to existing data

        // Update loaded pages to prevent fetching the same page again
        setLoadedPages((prevLoadedPages) => {
          const updatedLoadedPages = new Set(prevLoadedPages);
          updatedLoadedPages.add(newPageNo);
          return updatedLoadedPages;
        });

        // Update page number state for future requests
        setPageNo(newPageNo);

        // If fewer items are returned than requested, stop loading
        if (response.payload.length < defaultParams?.rowCountPerPage) {
          setHasMoreData(false); // No more data available, hide "Load More"
          hideLoader();
        }
      } else {
        hideLoader();
        setHasMoreData(false);
      }
    });
  };

  const formatDate = (date) => {
    // if (date !== null) {
    //   const d = new Date(date);
    //   const month = String(d.getMonth() + 1).padStart(2, "0"); // Get month and pad with leading zero if necessary
    //   const day = String(d.getDate()).padStart(2, "0"); // Get day and pad with leading zero if necessary
    //   const year = d.getFullYear(); // Get the full year
    //   return `${month}/${day}/${year}`; // Return the formatted date
    // } else {
    //   return null;
    // }
    if (date) {
      const d = new Date(date);

      // Check if date is valid
      if (!isNaN(d.getTime())) {
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const year = d.getFullYear();
        return `${month}/${day}/${year}`;
      } else {
        return null; // Invalid date
      }
    } else {
      return null; // null, undefined, or empty
    }

  };

  const handleSearch = async (IsLoadMore, InmateIDFilter) => {
    try {
      // Calculate the new page number
      let newPageNo = 1;
      setIsSearch(true);


      if (IsLoadMore) {
        newPageNo = searchpageNo + 1;
        if (searchloadedPages.has(newPageNo)) {
          setHasMoreData(false);
          return;
        }
      } else {
        setFilteredInboxMessageList([]);
        const resetLoadedPages = new Set();
        resetLoadedPages.add(newPageNo); // Add the first page to prevent duplicate fetches
        setSearchLoadedPages(resetLoadedPages);
      }

      const { InmateID, FromDate, ToDate, Subject, StatusOptions } =
        findInboxMessage;
      if (!FromDate) {
        setFindInboxMessage((prevState) => ({
          ...prevState,
          FromDate: getBeforeDate(30),
        }));
      }
      if (!ToDate) {
        setFindInboxMessage((prevState) => ({
          ...prevState,
          ToDate: getcurrentDate(1),
        }));
      }
        const statusFilter = getStatusString(StatusOptions); // Convert StatusOptions to the appropriate value

        // Prepare the request payload based on defaultParams and the search filters
        const requestPayload = {
        ...defaultParams, // Spread the defaultParams to maintain initial values
        inmateID:
          InmateIDFilter !== null && InmateIDFilter != undefined
            ? InmateIDFilter
            : InmateID
              ? InmateID
              : 0,
        fromDate: !FromDate
          ? formatDate(getBeforeDate(30))
          : formatDate(FromDate), // Format fromDate as mm/dd/yyyy
        toDate: !ToDate ? formatDate(getcurrentDate(1)) : formatDate(ToDate),
        messageStatus: statusFilter === 0 ? 0 : StatusOptions, // Adjust MessageStatus based on filter
        subject: Subject ? Subject : "",
        pageNo: newPageNo, // Always start with page 1 for the search
        rowCountPerPage: 15, // Set the number of rows per page
      };

      // Call the API to fetch the filtered data
      showLoader();
      const response = await dispatch(
        inboxActions.LoadInboxMessages({
          ...requestPayload,
          append: true, // Indicate this is not for appending
        })
      );
      CreateEventLogTextFileForInbox(
        dispatch,
        `Searched  Inbox Message List Using - InmateID " ${findInboxMessage?.InmateID} " MessageSubject-" ${findInboxMessage?.Subject} "FromDate" ${findInboxMessage?.FromDate} "ToDate" ${findInboxMessage?.ToDate} "Status" ${findInboxMessage?.StatusOptions}`,
        "---",
        JSON?.stringify(response),
        " Message Count - " + response?.length
      );

      if (response?.payload && response?.payload.length > 0) {
        hideLoader();
        if (newPageNo === 1) {
          setHasMoreData(true);
          setFilteredInboxMessageList([]);
          // Ensure the clearing takes effect before setting new data
          // setTimeout(() => {
          setFilteredInboxMessageList(response.payload);
          // }, 0);
        } else {
          setFilteredInboxMessageList((prev) => [...prev, ...response.payload]); // Append new data to existing data
        }

        // Update loaded pages to prevent fetching the same page again
        setSearchLoadedPages((prev) => {
          const updatedSearchLoadedPages = new Set(prev);
          updatedSearchLoadedPages.add(newPageNo);
          return updatedSearchLoadedPages;
        });

        // Update page number state for future requests
        setSearchpageNo(newPageNo); // Increment page number for next load

        // If fewer items are returned than requested, stop loading
        if (response.payload.length < defaultParams.rowCountPerPage) {
          setHasMoreData(false); // No more data available, hide "Load More"
        }
      } else {
        // Stop loading if no data is returned
        setHasMoreData(false);
      }
    } catch (error) {
      console.error("Error fetching search data:", error);
    } finally {
      hideLoader();
      isRestoringFilterRef.current = false; // search cycle is over — safe to let SignalR refresh now
    }
  };

  // Reset to clear state and show all items
  // const handleReset = () => {

  //   setIsSearch(false);
  //   setFindInboxMessage(InitialFindInboxMessage); // Reset findInboxMessage to initial state
  //   LoadInboxItems();
  // };

  const handleReset = () => {
    setIsSearch(false);

    // Ensure `InmateID` is explicitly set to 0
    if (location.state?.findInboxMessage) {
      location.state.findInboxMessage.InmateID = 0;
    }

    // Reset findInboxMessage to its initial state
    setFindInboxMessage(InitialFindInboxMessage);

    // Reload inbox items
    LoadInboxItems();

    CreateEventLogTextFileForInbox(
      dispatch,
      `Reset Button clicked in Inbox Message List - ${inboxMessagesList.length} Records per page "`,
      "---",
      JSON?.stringify(inboxMessagesList),
      " Message Count - " + inboxMessagesList.length
    );
  };

  const handleClickRedirect = (event, message, type) => {
    event.stopPropagation(); // Prevent event from bubbling up
    if (type === "COD") {
      setcancelBtnName(currentLang?.inbox?.Cancel);
      setPopMessage(currentLang?.InboxPopContent?.COD_Message);
      setconfirmBtnName(currentLang?.buttons?.BuyCredits);
      CreateEventLogTextFileForInbox(
        dispatch,
        `${currentMenuName} - Clicked COD message button in grid`,
        "---",
        "This is a 'Cash on Delivery' message. Credits need to be purchased to allow your contact to view your message. Please click on 'Buy Credits' button to proceed.",
        "Shows Buy Credits or Cancel Confirmation popup"
      );
    } else {
      setcancelBtnName(currentLang?.buttons?.No);
      setPopMessage(currentLang?.InboxPopContent?.Redirect_Page);
      setconfirmBtnName(currentLang?.buttons?.Yes);
      CreateEventLogTextFileForInbox(
        dispatch,
        `${currentMenuName} - Clicked Buy Credits button in grid`,
        "---",
        "This action redirects into another page, Are you sure you want to proceed?",
        "Shows YES or No Confirmation popup"
      );
    }
    setIsPurchaseHistoryConfirm(true);
    setPurchaseCreditInmateID(message.InmateID);
    setPurchaseMessageId(message.MessageID);
  };

  const handlePaymentMsg = () => {
    setIsPaymentMsg(false);
  };

  const handleCancelPurchaseHist = () => {
    setIsPurchaseHistoryConfirm(false);

    CreateEventLogTextFileForInbox(
      dispatch,
      `${currentMenuName} - Clicked No option In Redirect into Purchase Credit confirmation Popup`,
      "---",
      "---",
      "Hided confirmation Popup"
    );
  };

  // PurchaseCredit Redirect
  const handleClickPurchaseCreditRedirect = () => {
    const requestData = {
      userId: userID,
      inmateId: purchaseCreditInmateID,
      messageId: purchaseMessageId,
    };
    showLoader();
    dispatch(
      inboxActions.PublicInboxMessageSubjectPurchaseDisabled(requestData)
    ).then((response) => {
      const { Result, Notes } = response?.payload;
      hideLoader();
      setIsPurchaseHistoryConfirm(false);
      // LoadSentPhotos();
      switch (Result) {
        case -7:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Connection_Blocked);
          setIsPaymentMsg(true);
          handleSearch();
          break;
        case -8:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.No_longer_connected);
          setIsPaymentMsg(true);
          handleSearch();
          break;
        case -6:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Contact);
          setIsPaymentMsg(true);
          handleSearch();
          break;
        case -4:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Facility);
          setIsPaymentMsg(true);
          handleSearch();
          break;
        case -3:
          setPaymentMsg(Notes);
          setIsPaymentMsg(true);
          break;
        default:
          if (Result === 0) {
            setStoredValue("InmateID", purchaseCreditInmateID);
            navigate("/public/PurchaseCredits", {
              state: { previousPath: location.pathname },
            });
            storeCurrentRoute("/public/PurchaseCredits");
            //  dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());

            //purchaseCreditInmateID
            CreateEventLogTextFileForInbox(
              dispatch,
              `${currentMenuName} - Redirect into Purchase Credits page to Purchase Credits for Inmate ( Inmate ID - ${purchaseCreditInmateID} ) `,
              "/public/PurchaseCredits",
              "---",
              "---"
            );
          }
          break;
      }
    });
  };


  return (
    <>
      <div className="">
        <div className="header-title">
          {/* <FreshchatWidget /> */}
          <h5>
            {/* <i className="fa fa-envelope me-2"></i> */}
            {currentLang?.Inbox}
          </h5>
        </div>
      </div>

      <div className="row mb-5 pb-mobile">
        <div className="col-md-12">
          <ul className="list-group" id="divLoadList">
            {/* -------------------- Search - Section ---------------------- */}
            <div className="card w-100 border-radius-all shadow-sm">
              <div
                className="card-header d-flex align-items-center justify-content-between"
                style={{ background: "transparent", cursor: "pointer" }}
                onClick={toggleInformation}
              >
                <h4 className="mb-0 text-dark">
                  <i
                    className="fa fa-search me-2"
                    style={{ fontSize: "16px" }}
                  ></i>
                  {currentLang?.header?.Search}
                </h4>
                <i
                  id="itagInformation"
                  className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                    }`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
              {showSearchFields && (
                <div className="card-body bg-white padding-20">
                  <div className="row mb-4">
                    {/* Inmate Name */}
                    <div className="col-md-6">
                      <SelectInput
                        options={InmateDrpList}
                        value={findInboxMessage.InmateID}
                        onChange={(selectedOption) =>
                          handleSelectChange(selectedOption, "InmateID")
                        }
                        name="InmateID"
                        labelKey="label"
                        valueKey="value"
                        isClearable={true}
                        placeholder={currentLang?.placeholders?.cmbInmate}
                        label={currentLang?.labels?.Inmate}
                        required={false}
                        disabled={findInboxMessage.InmateID !== 0} // Disable if an inmate is selected
                      />
                    </div>

                    {/* Subject */}
                    <div className="col-md-6">
                      <TextInput
                        name="Subject"
                        id="Subject"
                        label={currentLang?.labels?.Subject}
                        value={findInboxMessage?.Subject}
                        handleChange={(e) => handleChange(e, "Subject")}
                        placeholder={currentLang?.labels?.Subject}
                        required={false}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSearch();
                          }
                        }}
                      />
                    </div>

                    {/* From Date */}
                    <div className="col-md-4">
                      <DatePickerComponent
                        value={findInboxMessage.FromDate}
                        onChange={(date) => handleDateChange(date, "FromDate")}
                        onBlur={() => handleBlur("FromDate")}
                        name="FromDate"
                        label={currentLang?.labels?.FromDate}
                        minDate={getBeforeDate(30)}
                        maxDate={findInboxMessage?.ToDate}
                        required={false}
                        disabled={false}
                        yearDropDown={true}
                        monthDropDown={true}
                        showTimeSelect={false}
                        clearOption={false}
                        onCopy={(e) => e.preventDefault()} // Restrict copy
                        onPaste={(e) => e.preventDefault()} // Restrict paste
                        onCut={(e) => e.preventDefault()} // Restrict cut
                      />
                    </div>

                    {/* To Date */}
                    <div className="col-md-4">
                      <DatePickerComponent
                        value={findInboxMessage.ToDate}
                        onChange={(date) => handleDateChange(date, "ToDate")}
                        onBlur={() => handleBlur("ToDate")}
                        name="ToDate"
                        label={currentLang?.labels?.ToDate}
                        required={false}
                        disabled={false}
                        yearDropDown={true}
                        monthDropDown={true}
                        showTimeSelect={false}
                        clearOption={false}
                        minDate={findInboxMessage?.FromDate ? findInboxMessage?.FromDate : new Date(getBeforeDate(30))}
                        maxDate={new Date()}
                        onCopy={(e) => e.preventDefault()} // Restrict copy
                        onPaste={(e) => e.preventDefault()} // Restrict paste
                        onCut={(e) => e.preventDefault()} // Restrict cut
                      />
                    </div>

                    {/* Status */}
                    <div className="col-md-4">
                      <SelectInput
                        options={StatusOptions}
                        value={findInboxMessage.StatusOptions}
                        onChange={(selectedOption) =>
                          handleSelectChange(selectedOption, "StatusOptions")
                        }
                        name="Status"
                        labelKey="label"
                        valueKey="value"
                        isClearable={false}
                        placeholder=""
                        label={currentLang?.labels?.Status}
                      />
                    </div>
                  </div>

                  <div className="text-center mt-1">
                    <div className="d-flex justify-content-start flex-wrap mt-1">
                      <button
                        type="submit"
                        className="btn btn-success me-2  font-size-14 mb-2"
                        onClick={() => handleSearch(false)}
                      >
                        <i className="fa-solid fa-magnifying-glass me-1"></i>
                        {currentLang?.buttons?.Search}
                      </button>
                      <button
                        type="button"
                        className="btn btn-grey me-2 font-size-14 mb-2"
                        onClick={handleReset}
                      >
                        <i className="fa-solid fa-arrow-rotate-left me-1 "></i>
                        {currentLang?.buttons?.Reset}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* -------------------- Message List Section ------------------ */}

            <ul className="list-group mt-3 border-radius-all" id="divLoadList">
              {loading ? (
                <div className="alert alert-info text-center" role="alert">
                  {currentLang?.ArchivedPage?.Loading}
                </div>
              ) : isSearch &&
                filteredInboxMessageList?.length === 0 &&
                !previousFilteredPhotos?.length ? (
                <div className="alert-light-red mb-3 font-size-16 p-3 text-center">
                  {currentLang?.info?.NoResult}
                </div>
              ) : (
                filteredInboxMessageList?.map((message, index) => (
                  <li
                    className="list-group-item d-flex align-items-center flex-wrap justify-content-between cursor-pointer"
                    onClick={() => handleClick(message)}
                    key={index} // Use unique key
                  >
                    {/* Photo details */}
                    <div className="d-flex align-items-center m-w-100 mo-mb-10">
                      <i
                        className="fa fa-user-circle fa-2x me-3"
                        aria-hidden="true"
                        style={{ paddingTop: "5px" }}
                      ></i>
                      {message.MessageStatus !== "Read" && (
                        <span
                          className="me-3 notificationBadge animate-blink"
                          style={{
                            position: "absolute",
                            top: "9px",
                            left: "36px",
                            // backgroundColor: "#4a9a93",
                            // color: "#FFFFFF",
                            borderRadius: "50%",
                            // padding: "3px 8px",
                            fontSize: "10px",
                            fontWeight: "bold",
                            display: "flex",
                            width: "22px",
                            height: "22px",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {message.PublicUserUnreadCount}
                        </span>
                      )}
                      <div>
                        <label className="fw-bold mb-0 profile-Name">
                          {" "}
                          {message.MessageFrom}
                        </label>
                        <br />
                        <span className="text-muted msg-desc hidden-text">
                          {message.MessageSubjectText}
                        </span>
                      </div>
                    </div>
                    <div className="justify-content-end">
                      <div>
                        <span className="text-muted float-right position-mobile">
                          {message.MessageSendDateTime}
                        </span>
                      </div>
                      <div className="d-flex justify-content-end align-items-center flex-wrap">
                        {message?.CODMessageCount > 0 && (
                          <button
                            id="btnBuyCredits"
                            type="button"
                            title={currentLang?.buttons?.CODMessage}
                            className="btn mb-1 btn-danger btn-sm ml-10 cursor-pointer"
                            style={{ padding: "4px 8px" }}
                            onClick={(event) =>
                              handleClickRedirect(event, message, "COD")
                            }
                          >
                            {currentLang?.buttons?.CODMessage}
                          </button>
                        )}
                        {/* <div className="">
                          {message.MessageStatus === "Read" && (
                            <i
                              title="Read"
                              className="fas fa-eye text-dark ml-10"
                              style={{ paddingTop: "7px" }}
                            ></i>
                          )}
                          {message.MessageStatus === "Waiting" && (
                            <i
                              title="Waiting"
                              className="fa fa-hourglass-start text-dark pt-2"
                            // style={{ paddingTop: "7px" }}
                            ></i>
                          )}
                          {message.MessageStatus === "Unread" && (
                            <i
                              title="Unread"
                              className="fa fa-eye-slash text-dark pt-2"
                            // style={{ paddingTop: "7px" }}
                            ></i>
                          )}
                          {message.MessageStatus === "Rejected" && (
                            <i
                              title="Rejected"
                              className="fa fa-thumbs-down text-dark pt-2"
                            // style={{ paddingTop: "7px" }}
                            ></i>
                          )}
                        </div> */}
                        {!(
                          message?.Blocked === 1 ||
                          message?.IsAllowSendReply === 0
                        ) && (
                            <button
                              id="btnBuyCredits"
                              type="button"
                              title={currentLang?.buttons?.BuyCredits}
                              className="btn mb-1 btn-success btn-sm ml-10 cursor-pointer"
                              style={{ padding: "4px 8px" }}
                              onClick={(event) =>
                                handleClickRedirect(event, message)
                              }
                            >
                              {/* Buy Credits */}
                              {currentLang?.buttons?.BuyCredits}
                            </button>
                          )}
                        <div className="d-flex align-items-center justify-content-center ">
                          <button className="btn btn-blue mb-1 btn-sm min-width-80 ml-10 cursor-default">
                            <h5 className="available-limit text-white">
                              ${message?.CreditBalance?.toFixed(2) || "0.00"}
                            </h5>
                          </button>
                        </div>
                      </div>
                    </div>
                  </li>
                ))
              )}
              {hasMoreData && filteredInboxMessageList?.length > 0 && (
                <li className="list-group-item">
                  <div className="d-flex justify-content-center mb-n3">
                    <div className="div-load-more-data inbox panel footer-load-more">
                      <label
                        className="text-decoration-none text-danger fs-5 cursor-pointer load-more-button"
                        onClick={
                          isSearch ? () => handleSearch(true) : handleLoadMore
                        }
                      >
                        <i class="fa-solid fa-plus me-1 font-size-14">
                        </i>{currentLang?.buttons?.LoadMore}
                      </label>
                    </div>
                  </div>
                </li>
              )}
            </ul>
          </ul>
        </div>
        {loader}
      </div>
      <ConfirmationModal
        show={isPurchaseHistoryConfirm}
        onHide={handleCancelPurchaseHist}
        onConfirm={handleClickPurchaseCreditRedirect}
        title={currentLang?.Message}
        message={
          popMessage || currentLang?.InboxPopContent?.Redirect_Page
        }
        closeButton={false}
        onconfirmname={confirmBtnName || currentLang?.buttons?.Yes}
        oncancelname={cancelBtnName || currentLang?.buttons?.No}
      />
      <ConfirmationModal
        show={isPaymentMsg}
        onHide={handlePaymentMsg}
        onConfirm={handlePaymentMsg}
        title={currentLang?.Message}
        message={paymentMsg}
        showCancelButton={false}
        closeButton={false}
        onconfirmname={currentLang?.buttons?.OK}
      />
    </>
  );
};

export default React.memo(Inbox);
